import React, { createContext, useState, useContext, useEffect } from 'react';

// 1. Creamos el Contexto
// Este es el "tablero de anuncios" que estará vacío inicialmente.
const AuthContext = createContext(null);

// 2. Creamos el Proveedor del Contexto (AuthProvider)
// Este es el componente "gerente" que manejará toda la lógica.
export const AuthProvider = ({ children }) => {

    // Los estados donde guardaremos la información de autenticación.
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);

    // 3. Efecto para verificar si ya hay una sesión al cargar la app
    // Esto es para que el usuario no tenga que iniciar sesión cada vez que refresca la página.
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');

        if (storedToken && storedUser) {
            setToken(storedToken);
            setUser(JSON.parse(storedUser)); // JSON.parse convierte el string de vuelta a un objeto
        }
    }, []); // El array vacío [] significa que este efecto se ejecuta solo una vez, cuando el componente se monta.

    // 4. Función para manejar el inicio de sesión
    // Esta función será llamada desde nuestro componente Login.
    const login = (loginData) => {
        setUser(loginData.user);
        setToken(loginData.token);
        localStorage.setItem('token', loginData.token);
        localStorage.setItem('user', JSON.stringify(loginData.user)); // Guardamos el usuario como un string JSON
    };

    // 5. Función para manejar el cierre de sesión
    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    };

    // 6. El valor que compartiremos con el resto de la aplicación
    // Incluye el estado (si hay un usuario/token) y las funciones para cambiarlo.
    const value = {
        user,
        token,
        login,
        logout,
    };

    // Retornamos el proveedor que envuelve a los componentes hijos (children)
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 7. Creamos un "hook" personalizado para usar el contexto más fácilmente
// En lugar de importar useContext y AuthContext en cada componente, solo importaremos useAuth.
export const useAuth = () => {
    return useContext(AuthContext);
};